import { formatCurrency, TYPE_BADGE_STYLES } from './utils';

const LedgerTable = ({ ledgerData, periodTotals, closingBalance }) => {
    return (
        <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden tw-mb-5">
            <div className="tw-overflow-x-auto">
                <table className="tw-w-full tw-text-sm">
                    <thead>
                        <tr className="tw-bg-gray-50 tw-border-b tw-border-gray-100">
                            <th className="tw-text-left tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Date</th>
                            <th className="tw-text-left tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Description</th>
                            <th className="tw-text-left tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Type</th>
                            <th className="tw-text-left tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Ref/Chq No.</th>
                            <th className="tw-text-right tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Debit (Dues)</th>
                            <th className="tw-text-right tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Credit (Paid)</th>
                            <th className="tw-text-right tw-px-4 tw-py-3 tw-text-[11px] tw-font-semibold tw-text-gray-400 tw-uppercase tw-tracking-wider">Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ledgerData.map((row, index) => (
                            <tr
                                key={index}
                                className={`tw-border-b tw-border-gray-50 ${row.isOpening ? 'tw-bg-blue-50/40' : 'hover:tw-bg-gray-50/50'} tw-transition-colors`}
                            >
                                <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-gray-600 tw-whitespace-nowrap">{row.date}</td>
                                <td className={`tw-px-4 tw-py-3 tw-text-xs ${row.isOpening ? 'tw-font-semibold tw-text-gray-700' : 'tw-text-gray-700'}`}>
                                    {row.description}
                                </td>
                                <td className="tw-px-4 tw-py-3">
                                    {row.type ? (
                                        <span className={`tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium ${TYPE_BADGE_STYLES[row.type] || 'tw-bg-gray-50 tw-text-gray-500'}`}>
                                            {row.type}
                                        </span>
                                    ) : (
                                        <span className="tw-text-[10px] tw-text-gray-400">-</span>
                                    )}
                                </td>
                                <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">
                                    {row.refNo || (row.isOpening ? '' : '-')}
                                </td>
                                <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-right tw-whitespace-nowrap">
                                    {row.debit !== null && row.debit !== undefined ? (
                                        <span className={row.debit > 0 ? 'tw-text-gray-800 tw-font-medium' : 'tw-text-gray-400'}>
                                            {formatCurrency(row.debit)}
                                        </span>
                                    ) : ''}
                                </td>
                                <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-right tw-whitespace-nowrap">
                                    {row.credit !== null && row.credit !== undefined ? (
                                        <span className={row.credit > 0 ? 'tw-text-emerald-600 tw-font-medium' : 'tw-text-gray-400'}>
                                            {formatCurrency(row.credit)}
                                        </span>
                                    ) : ''}
                                </td>
                                <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-right tw-font-semibold tw-text-gray-800 tw-whitespace-nowrap">
                                    {formatCurrency(row.balance)}
                                </td>
                            </tr>
                        ))}

                        {/* Period Totals */}
                        <tr className="tw-bg-gray-50 tw-border-t-2 tw-border-gray-200">
                            <td colSpan={4} className="tw-px-4 tw-py-3 tw-text-xs tw-font-semibold tw-text-gray-600 tw-text-right">
                                Period Totals:
                            </td>
                            <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-right tw-font-bold tw-text-gray-800">
                                <span className="tw-text-[10px] tw-text-gray-400 tw-mr-0.5">&#8377;</span>
                                {formatCurrency(periodTotals.debit)}
                            </td>
                            <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-right tw-font-bold tw-text-emerald-600">
                                <span className="tw-text-[10px] tw-mr-0.5">&#8377;</span>
                                {formatCurrency(periodTotals.credit)}
                            </td>
                            <td className="tw-px-4 tw-py-3 tw-text-xs tw-text-right tw-font-bold tw-text-blue-600">
                                <span className="tw-text-[10px] tw-mr-0.5">&#8377;</span>
                                {formatCurrency(closingBalance)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LedgerTable;
